(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["amy-inquiry-intro"] && !Shopify.designMode) return;
  try {
    (() => {
    const styleMarker = 'data-amy-form-width-vars';

    const widenForm = (embed) => {
      const apply = () => {
        const root = embed.shadowRoot;
        if (!root || root.querySelector('style[' + styleMarker + ']')) return;

        const style = document.createElement('style');
        style.setAttribute(styleMarker, '');
        style.textContent = [
          ':host {',
          '  --inline-container-max-width: 100% !important;',
          '  --forms-padding-left: 0px !important;',
          '  --forms-padding-right: 0px !important;',
          '}',
        ].join('\n');
        root.appendChild(style);
      };

      apply();
      window.requestAnimationFrame(apply);
    };

    const init = () => {
      document.querySelectorAll('.section-wrapper').forEach((wrapper) => {
        if (!wrapper.querySelector('.amy-inquiry-intro')) return;
        wrapper.querySelectorAll('shopify-forms-embed').forEach(widenForm);
      });
    };

    customElements.whenDefined('shopify-forms-embed').then(init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
